import { formatCnpj } from "utils/federal-tax-id";

/** Formato de leitura do CNPJ. Delega para o formatador único (`utils/federal-tax-id`). */
export function maskCNPJ(cnpj: string): string {
  return formatCnpj(cnpj);
}
